module.exports = __webpack_public_path__ + "img/banner-24.d3fb51a8.jpg";